import gsap from "gsap";

window.scrollTo(0, 0);
const tl = gsap.timeline();

window.addEventListener("load", function () {
  const root = document.getElementById("root");
  const header = document.querySelector("#header");
  const title = document.querySelector(".introduction__title");
  const text = document.querySelector(".introduction__text");
  const footer = document.querySelector("#footer");

  if (!root || !header || !title || !text || !footer) return;

  tl.from(root, { autoAlpha: 0 });

  const viewportHeight = document.documentElement.clientHeight;
  const titleYOrigin = title.getBoundingClientRect().y;

  tl.to(title, {
    y: viewportHeight / 2 - titleYOrigin,
    yPercent: -50,
    duration: 0,
  });

  tl.from(title, {
    opacity: 0,
    scale: 2,
    filter: "blur(0.3em)",
    duration: 2.3,
    ease: "Expo.easeInOut",
  });

  tl.to(title, {
    transform: "translate(0, 0)",
    duration: 1.6,
    ease: "power1.inOut",
  });

  tl.from([header, text, footer], {
    opacity: 0,
    duration: 1.5,
  });
});
